// // Use $ instead of $uery without replacing global $
// (function ($) {
//     $(document).ready(function () {
//         $('.image-with-content .overlay-image .image-slider .img-overlay-wrap').each(function () {
//
//             // $(this).slick({
//             //     draggable: true,
//             //     autoplay: false,
//             //     dots: true,
//             //     swipe: true,
//             //     speed: 700,
//             //     dotsClass: 'custom-dots',
//             //     infinite: true,
//             //     nextArrow: $(this).parent().find('.next'),
//             //     prevArrow: $(this).parent().find('.prev'),
//             //     responsive: [
//             //         {
//             //             breakpoint: 575,
//             //             settings: {
//             //                 dots: false,
//             //                 arrows: true
//             //             }
//             //         }
//             //     ]
//             // });
//         });
//         $('body .image-with-content .content-wrap .col-outer .img-outer .img-wrap').click(function () {
//             $(".custom-dots").css({'display': 'none'});
//             var index = $(this).index();
//             $(this).parents('.col-outer').find('.overlay-image').addClass('active');
//             $(this).parents('.col-outer').find('.overlay-image .custom-dots li:eq(' + index + ')').trigger('click');
//         });
//
//         $('body .image-with-content .content-wrap .overlay-image .close').click(function () {
//             $(this).parents('.overlay-image').removeClass('active');
//         });
//
//            $('#professional-developement .nav .prev').on('click', function () {
//                  $('#professional-developement .img-overlay-wrap').slick("slickPrev");
//             });
//             $('#professional-developement .nav .next').on('click', function () {
//                 $('#professional-developement .img-overlay-wrap').slick("slickNext");
//             });
//         $('#Blach-university-block .nav .prev').on('click', function () {
//             $('#Blach-university-block .img-overlay-wrap').slick("slickPrev");
//         });
//         $('#Blach-university-block .nav .next').on('click', function () {
//             $('#Blach-university-block .img-overlay-wrap').slick("slickNext");
//         });
//         $('#Engineering-block .nav .prev').on('click', function () {
//             $('#Engineering-block .img-overlay-wrap').slick("slickPrev");
//         });
//         $('#Engineering-block .nav .next').on('click', function () {
//             $('#Engineering-block .img-overlay-wrap').slick("slickNext");
//         });
//     });
//     // $(window).on('load scroll', function () {
//     //
//     //     $('body .image-with-content .content-wrap .col-outer.img-left .img-outer .img-wrap').click(function () {
//     //         // $('body').css({'overflow':'hidden'});
//     //         // $('body .image-with-content').css({'overflow':'visible'});
//     //     });
//     //     $('body .image-with-content .overlay-image .close').click(function () {
//     //         // $('body').css({'overflow':'visible'});
//     //         // $('body .image-with-content').css({'overflow':'hidden'});
//     //     });
//     //
//     // });
//
// })(jQuery);